// Mock dashboard API
export default {
  getStatistics: async () => {
    await new Promise(resolve => setTimeout(resolve, 300))
    return {
      todayOutbound: 128,
      pendingOrders: 15,
      warningCount: 3,
      totalProducts: 1286
    }
  },
  
  getWarningList: async () => {
    await new Promise(resolve => setTimeout(resolve, 300))
    return [
      { id: 1, name: '商品A', stock: 10, threshold: 20 },
      { id: 2, name: '商品B', stock: 5, threshold: 15 },
      { id: 3, name: '商品C', stock: 8, threshold: 25 }
    ]
  },
  
  getWeeklyOutbound: async () => {
    await new Promise(resolve => setTimeout(resolve, 300))
    return [
      { date: '周一', count: 120 },
      { date: '周二', count: 150 },
      { date: '周三', count: 130 },
      { date: '周四', count: 180 },
      { date: '周五', count: 160 },
      { date: '周六', count: 90 },
      { date: '周日', count: 70 }
    ]
  }
} 